const styles = theme => ({
  searchBar: {
    height: '43px',
    width: '500px',

    '& .outlinedInput fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.23) !important',
      borderWidth: '1px !important'
    },

    '& input': {
      height: '43px',
      width: 'inherit',
      borderRadius: '4px',
      fontSize: '1rem',
      color: 'rgba(237, 237, 237, 0.8)',
      background: 'rgba(0, 0, 0, 0.21)',
      boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.2)',
      borderStyle: 'solid',
      padding: '0 1rem',
      boxSizing: 'border-box',
      borderColor: 'transparent',

      '&::placeholder': {
        color: 'rgba(237, 237, 237, 0.8)'
      },

      '&:focus': {
        outline: 'none'
      }
    },

    '& .results': {
      backgroundColor: 'white',
      borderRadius: '4px',
      maxHeight: '38rem',
      overflow: 'auto',
      boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1)'
    },

    '& .result': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 1rem',
      cursor: 'pointer',
      height: '53px',
      borderBottom: '1px solid #ededed',
      color: '#4a4a4a',
      letterSpacing: '0.2px',

      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        color: 'black',
        textDecoration: 'none'
      },

      '&.active': {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        color: 'black',
        textDecoration: 'none'
      },

      '& mark': {
        backgroundColor: 'transparent',
        fontWeight: 'bold'
      }
    },

    '& .archived': {
      marginLeft: '0.9rem',
      fontSize: '0.6rem',
      color: theme.palette.text.contrastOnLightGray,
      letterSpacing: '1.5px'
    },

    '& .email': {
      fontFamily: 'Helvetica',
      fontSize: '0.9rem',
      color: theme.palette.text.contrastOnLightGray
    }
  }
})

export default styles
